<section class="mb-10 mb-md-14">
    <app-showroom></app-showroom>
</section>

<section class="mb-10 mb-md-14">
    <app-meet-form></app-meet-form>
</section>

<section class="bg-gray-150 py-10 py-md-14 mb-md-14">
    <app-our-products></app-our-products>
</section>

<section class="mb-10 mb-md-14">
    <app-our-partners></app-our-partners>
</section>

<section class="mb-10 mb-md-14">
    <app-our-partners-logos></app-our-partners-logos>
</section>
